<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
      <!--begin::sidebar-->
      <sidebar-component classMenu="Users"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            "
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                
                 <div class="card-header">
                      <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                       &nbsp;&nbsp;&nbsp;
                      <h6 class="card-title mb-0 float-start" style="padding-left: 25px">{{ $t("userAccessEdit") }}</h6>
                      <button
                        class="btn btn-default float-end"
                        @click="resetForm"
                        type="button"
                      >
                      <i class="link-icon" data-feather="repeat"></i>
                        {{ $t("resetFormTxt") }}
                      </button>
                </div>

                <div class="card-body">
                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div
                      class="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>
                  <!--end::loading-data-->

                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-between
                        align-items-baseline
                        mb-2
                      "
                    >
                    
                    </div>


                    <div class="row mb-3">
                      <!-- <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">User Type</label>
                      </div> -->
                      <!-- <div class="col-lg-8">
                        <v-select
                          :options="fetchUserType"
                          return-object
                           label="description"
                          v-model="user_type"
                        ></v-select>

                        <div v-if="errors.user_type">
                          <div
                            v-for="error in errors.user_type"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div> -->
                    </div>

                    
                     <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t("nameTxt")
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="nameTxt"
                          :placeholder="$t('nameTxt')"
                          v-model="forms.name"
                          required
                        />
                        <div v-if="errors.name">
                          <div
                            v-for="error in errors.name"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t("usernameTxt")
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="usernameTxt"
                          :placeholder="$t('usernameTxt')"
                          v-model="forms.username"
                          required
                        />
                        <div v-if="errors.username">
                          <div
                            v-for="error in errors.username"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                     <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t("password")
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="password"
                          class="form-control"
                          id="password"
                          :placeholder="$t('password')"
                          v-model="forms.password"
                         
                        />
                        <div v-if="errors.password">
                          <div
                            v-for="error in errors.password "
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>




                     <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t("emailAddress")
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="email"
                          class="form-control"
                          id="emailAddress"
                          :placeholder="$t('emailAddress')"
                          v-model="forms.email"
                          required
                        />
                        <div v-if="errors.email">
                          <div
                            v-for="error in errors.email"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                    <!-- <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t("companyCode")
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        
                    
                        <v-select
                          v-if="companyCode == 'LINC'"
                          :options="fetchCompany"
                          v-model="company"
                          label="code"
                          return-object
                          @search="asyncSearchCompany"
                          
                        ></v-select>

                        <v-select
                          v-if="companyCode != 'LINC'"
                          :options="fetchCompanyNotLinc"
                          v-model="company"
                          label="code"
                          return-object
                          @search="asyncSearchCompanyNotLinc"
                        
                        ></v-select>

                        <div v-if="errors.companyId">
                          <div
                            v-for="error in errors.companyId"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div> -->


                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t("roleTxt")
                        }}</label>
                      </div>
                      <div class="col-lg-8">

                        <!-- <select class="form-control" name="roleId" id="roleId" v-model="forms.roleId" >
                            <option  v-for="(a, index) of fetchRole" :value="a.role_id" :key="index">{{a.name}}</option>
                        </select> -->

                        <v-select
                          :options="fetchRole"
                          v-model="role"
                          label="name"
                          return-object
                          @search="asyncSearchRole"
              
                        ></v-select>

                        <div v-if="errors.roleId">
                          <div
                            v-for="error in errors.roleId"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                   
                    <div class="card-footer">
                     <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      
                      &nbsp;&nbsp;&nbsp;
                      <button class="btn btn-primary float-end btn-sm" type="submit">
                           <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "UsersEdit",
  props: {},
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      companyCode: "",
      fetchRole:[],
      fetchCompany:[],
      fetchCompanyNotLinc:[],
      forms: [],
      company:[],
      role:[],
      permision_role:[],
      fetchUserType:[],
      user_type:[],
    };
  },
  watch: {},
  methods: {

    resetForm() {
      this.forms.name = "";
      this.forms.username = "";
      this.forms.password = "";
      this.forms.email = "";
      this.forms.company_id = "";
      this.forms.role_id = "";
      this.company=[];
      this.role=[];
    },

    backForm() {
       window.location.href = "/users";
    },


    loadData(id) {
      const baseURI = this.$settings.endPoint + "user/detail/"+id;
      this.isLoading = true;
      return this.$http
        .get(
          baseURI,{ timeout: 10000 }
        )
        .then((response) => {
            
            this.forms=response.data.datas;
            // this.company=this.forms.company_detail;
            this.role=this.forms.role;
            // this.user_type=response.data.datas.user_type_detail
            this.isLoading = false;
        }).catch(error => {
            this.isLoading = false;
          if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
          }else{

            if (error.response) {
              if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else if (error.response.status === 401) {
                  this.$router.push("/authorized-error");
              }else{
                  this.$router.push('/page-not-found');
              }
            }

          }
        });
    },

    loadRole() {
      const baseURI = this.$settings.endPoint + "/role?limit=10";
     
      return this.$http
        .get(
          baseURI,{ timeout: 10000 }
        )
        .then((response) => {
            this.fetchRole=response.data.datas.data;
        }).catch(error => {
            this.isLoading = false;
          if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
          }else{

            if (error.response) {
              if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else if (error.response.status === 401) {
                  this.$router.push("/authorized-error");
              }else{
                  this.$router.push('/page-not-found');
              }
            }

          }
        });
    },

    asyncSearchRole(ev){
      const baseURI = this.$settings.endPoint + "role?name="+ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchRole = response.data.datas.data;
      });
    },


    loadCompany() {
      const baseURI = this.$settings.endPoint + "company?limit=10";
     
      return this.$http
        .get(
          baseURI,{ timeout: 10000 }
        )
        .then((response) => {
            this.fetchCompany=response.data.datas.data;
        }).catch(error => {
            this.isLoading = false;
          if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
          }else{

            if (error.response) {
              if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else if (error.response.status === 401) {
                  this.$router.push("/authorized-error");
              }else{
                  this.$router.push('/page-not-found');
              }
            }

          }
        });
    },


    // loadCompanyNotLinc() {
    //   const baseURI =
    //     this.$settings.endPoint + `company/select`;

    //   return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
    //     this.fetchCompanyNotLinc = response.data.datas.data;
    //   }).catch(error => {
    //         this.isLoading = false;
    //       if(error.code == "ECONNABORTED"){
    //         this.error(this.$t("check_internet_connection_txt"));
            
    //       }else{

    //         if (error.response) {
    //           if(error.response.status === 422) {
    //                   this.errors = error.response.data.errors;
    //                   this.resultError(error.response.data.errors);
    //           }else if (error.response.status === 500) {
    //               this.$router.push('/server-error');
    //           }else if (error.response.status === 401) {
    //               this.$router.push("/authorized-error");
    //           }else{
    //               this.$router.push('/page-not-found');
    //           }
    //         }

    //       }
    //     });
    // },


    // asyncSearchCompany(ev){
    //   const baseURI = this.$settings.endPoint + "company?code="+ev;

    //   return this.$http.get(baseURI).then((response) => {
    //     this.fetchCompany = response.data.datas.data;
    //   });
    // },

    // asyncSearchCompanyNotLinc(ev){
    //   const baseURI = this.$settings.endPoint + "company/select?code="+ev;

    //   return this.$http.get(baseURI).then((response) => {
    //     this.fetchCompanyNotLinc = response.data.datas.data;
    //   });
    // },

    submitData() {
       this.fade(true);
  
          // this.forms.company_id=this.company.company_id;
          this.forms.role_id=this.role.role_id;
          // this.forms.user_type=this.user_type.value;
          const baseURI  =  this.$settings.endPoint+"user/update/"+this.forms.user_id;
          this.$http.put(baseURI,this.forms).then((response) => {
              this.loading();
              if(response.data.status === 200) {
              //this.resetForm();
                  this.errors = [];
                  this.success(response.data.datas.messages);

                  //window.history.back();
                  var params = this.$onRandom(this.forms.user_id);
                    window.location.href = "/users/detail/" + params + "?status=200&msg=Successfully";

              }else{
                  this.errors = response.data.errors;
                  this.resultError(response.data.errors);
              }
          }).catch(error => {
              this.loading();
              if (error.response) {
              if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else{
                  this.$router.push('/page-not-found');
              }
              }
              //this.resetForm();
          });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });

    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.detailUser     = userDatas.sub;
      //  this.companyCode = this.detailUser.company_detail.code;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'UserController'){
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if(!rolePermision.method_update){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },

    getSystemCode() {
      const baseURI = this.$settings.endPoint + "system-code/select?system_code=COMPANY_TYPE";
       
      this.isLoading = true
      return this.$http
        .get(
           baseURI,
          { timeout: 10000 }
        )
        .then((response) => {
          var rows = response.data.datas.data;
          if(rows.length > 0){
            this.fetchUserType = rows
          } 
          
           this.isLoading = false
        }).catch(error => {
           this.isLoading = false
          if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
          }else{

            if (error.response) {
              if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else if (error.response.status === 401) {
                  this.$router.push("/authorized-error");
              }else{
                  this.$router.push('/page-not-found');
              }
            }

          }
          // return []
        });
    },

    
  },
  events: {},
  created: function () {},
  mounted() {

      var params = this.$onBehind(this.$route.params.id);
      this.loadData(params[0]);
      this.loadRole();
      // this.loadCompany();
      // this.loadCompanyNotLinc();
      this.fetchIt();
   // this.getSystemCode();
  },
};
</script>
<style scoped>
button.gm-ui-hover-effect {
  visibility: hidden;
}

.blur-content{
  filter: blur(5px); 
  pointer-events: none;
  
}
</style>